<template>
    <keep-alive>
        <component :is=getForm></component>
    </keep-alive>
</template>


<script>
import {mapGetters, mapActions} from 'vuex';
import BasicInformation from './journey/BasicInformation';
import CompanyProfile from './journey/CompanyProfile';
import SearchOptimisation from './journey/SearchOptimisation';
import Category from './journey/Category';
import YourProfile from './journey/YourProfile';
import ListingPreview from './journey/ListingPreview';
import SingleTestimonial from './testimonials/SingleTestimonial';
import Sidebar from './sidebar/Sidebar';
import CodePin from './journey/CodePin';


export default {
components:{
    'basic-information':BasicInformation,
    'company-profile':CompanyProfile,
    'seo':SearchOptimisation,
    'category':Category,
    'profile':YourProfile,
    'single-testimonial':SingleTestimonial,
    'sidebar':Sidebar,
    'listing-preview':ListingPreview,
    'email-confirmation':CodePin
},
mounted(){
    console.log('here');
    this.initialiseState('register');
},
computed:{
    ...mapGetters([
        'getForm',
    ]),
},
methods:{
    ...mapActions([
        'initialiseState'
    ])
}

}
</script>
